import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const verify = reatomAsync((ctx, code: string, email: string) => {
  return API.authApi.authControllerVerifyAccount(code, email);
}).pipe(withDataAtom(null), withIsLoadingAtom());
